// extracted by mini-css-extract-plugin
export default {"page":"UE-z","cartModal":"VE-z","checkout":"WE-z","placeholder":"XE-z","account":"YE-z"};